module.exports = __webpack_public_path__ + "static/zuri-vtol-11m-test-behind-scenes-subscale-flight-0c902ccf187e6beaa59ab4f0dbb0d1ad.mp4";